import { useState, useRef } from "react";
import { FaEye, FaEyeSlash, FaArrowLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { setToken } from "../redux/userSlice";
import axios from "axios";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import Loader from "../Components/Loader";
import { SyncLoader } from "react-spinners";

const ConnectModal = ({ onClose }) => {
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const { data } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  // Create a ref for the Connect button
  const connectButtonRef = useRef(null);

  // const handleLogin = async () => {
  //   try {
  //     setLoading(true);
  //     setError(false);

  //     const loginResponse = await axios.post(
  //       `http://159.203.35.6:8080/wallet/logIn`,
  //       {
  //         email: "kashan@gmail.com",
  //         password: password,
  //       }
  //     );

  //     if (loginResponse.status === 200) {
  //       dispatch(setToken(loginResponse.data.token));

  //       try {
  //         // Generate EVM wallet
  //         const evmResponse = await axios.post(
  //           `http://159.203.35.6:8080/wallet/generateEvmWallet`,
  //           {},
  //           {
  //             headers: { Authorization: `Bearer ${loginResponse.data.token}` },
  //           }
  //         );

  //         // Generate Solana wallet
  //         const solResponse = await axios.post(
  //           `http://159.203.35.6:8080/wallet/genSolWallet`,
  //           {},
  //           {
  //             headers: { Authorization: `Bearer ${loginResponse.data.token}` },
  //           }
  //         );

  //         // Check if both responses are successful
  //         if (evmResponse.status === 200 && solResponse.status === 200) {
  //           Swal.fire({
  //             toast: true,
  //             position: "top-end",
  //             icon: "success",
  //             title: "Wallet connected successfully",
  //             showConfirmButton: false,
  //             timer: 2000,
  //             background: "#be6bed",
  //             color: "#fff",
  //           });
  //           navigate("/wallet"); // Navigate to wallet page
  //           onClose();
  //         } else {
  //           throw new Error("Wallet generation failed");
  //         }
  //       } catch (error) {
  //         console.log("Error Response:", error.response);

  //         // Handle 403 status and navigate to connect-wal page
  //         if (error?.response?.status === 403) {
  //           Swal.fire({
  //             toast: true,
  //             position: "top-end",
  //             icon: "error",
  //             title: "Enter your password",
  //             showConfirmButton: false,
  //             timer: 2000,
  //             background: "#be6bed",
  //             color: "#fff",
  //           });
  //           navigate("/connect-wal"); // Navigate to the connect-wal page
  //           return;
  //         }
  //       }
  //     } else {
  //       throw new Error("Login failed");
  //     }
  //   } catch (error) {
  //     Swal.fire({
  //       toast: true,
  //       position: "top-end",
  //       icon: "error",
  //       title: "Incorrect password",
  //       showConfirmButton: false,
  //       timer: 2000,
  //       background: "#be6bed",
  //       color: "#fff",
  //     });
  //     setError(true);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const handleLogin = async () => {
    setLoading(true);
    setError(false);
  
    let token;
  
    // ─── 1) LOGIN ───────────────────────────────────────
    try {
      const loginRes = await axios.post(
        "http://159.203.35.6:8080/wallet/logIn",
        { email: "kashan@gmail.com", password }
      );
  
      if (loginRes.status !== 200) {
        throw new Error("LOGIN_FAILED");
      }
  
      token = loginRes.data.token;
      dispatch(setToken(token));
      localStorage.setItem("token", token);
  
    } catch (err) {
      console.error("Login error:", err);
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "error",
        title: "Incorrect password",
        showConfirmButton: false,
        timer: 2000,
        background: "#be6bed",
        color: "#fff",
      });
      setError(true);
      setLoading(false);
      return;  // stop if login fails
    }
  
    // ─── 2) WALLET GENERATION ───────────────────────────
    try {
      const [evmRes, solRes] = await Promise.all([
        axios.post(
          "http://159.203.35.6:8080/wallet/generateEvmWallet",
          {},
          { headers: { Authorization: `Bearer ${token}` } }
        ),
        axios.post(
          "http://159.203.35.6:8080/wallet/genSolWallet",
          {},
          { headers: { Authorization: `Bearer ${token}` } }
        ),
      ]);
  
      // Log statuses
      console.log("EVM wallet status:", evmRes.status);
      console.log("Sol wallet status:", solRes.status);
  
      // Accept any 2xx success
      if (
        evmRes.status >= 200 && evmRes.status < 300 &&
        solRes.status >= 200 && solRes.status < 300
      ) {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "success",
          title: "Wallet connected successfully",
          showConfirmButton: false,
          timer: 2000,
          background: "#be6bed",
          color: "#fff",
        });
  
        localStorage.setItem("passwordVerified", "true");
        navigate("/wallet");
        onClose();
      } else {
        throw new Error("Unexpected status from wallet generation");
      }
  
    } catch (err) {
      console.error("Wallet generation error:", err);
  
      const status = err?.response?.status;
      if (status === 403) {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "error",
          title: "Enter your password",
          showConfirmButton: false,
          timer: 2000,
          background: "#be6bed",
          color: "#fff",
        });
        navigate("/connect-wal");
      
      }
    } finally {
      setLoading(false);
    }
  };
  
  
  

  return (
    <div className="connect-modal-overlay">
      <div className="connect-modal">
        <div className="connect-header">
          <button className="connect-back-btn" onClick={onClose}>
            <FaArrowLeft />
          </button>
          <h2 className="connect-title">Account</h2>
        </div>
        <div className="connect-content">
          <label className="connect-label">Enter your password</label>
          <div className="connect-password-container">
            <input
              type={showPassword ? "text" : "password"}
              className="connect-password-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  connectButtonRef.current.click(); // Trigger button click on Enter
                }
              }}
            />
            <button
              className="connect-password-toggle"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>
          <button
            ref={connectButtonRef} // Attach the ref here
            className="connect-button"
            onClick={handleLogin}
            disabled={loading}
          >
            {loading ? (
              // <div style={{ display: "flex", justifyContent: "center" }}>
              //   <span className="loader" style={{ height: "15px", width: "15px" }}></span>
              // </div>
              <SyncLoader color="white"  size={9} />
            ) : (
              "Connect"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConnectModal;


